export default {
  scorecard: {
    title: '스코어카드',
    content: '내용',
    award: 'ESG 어워드',
  },
  list_table_filter: {
    table_buyer_company_name: '평가 의뢰 기업',
    table_question_group_name: '조사표',
    table_status: '상태',
    table_issue_at: '발행일',
    table_sustaina_rate: 'ESG 등급',
    table_esg_score: 'ESG 스코어',
    table_operation: '조작',
    displayed_items_number: "{total}건 중 {start}–{end}건 표시",
    displayed_items_number_empty: '0건 중 0건 표시',
    no_data_display: '데이터를 찾을 수 없습니다',
    csv_modal_title: 'CSV 출력 내용을 선택해 주세요',
    csv_modal_answer_status_title: '응답 상황',
    csv_modal_answer_status_text: '피평가 기업의 응답 상황을 목록으로 출력합니다.',
    csv_modal_answer_title: '응답(500사 1파일씩)',
    csv_modal_answer_title_by_individual_company: '응답(1사 1파일씩)',
    csv_modal_answer_text: '피평가 기업의 응답 내용을 500사 1파일 형식으로 출력합니다.',
    csv_modal_answer_text_by_individual_company: '피평가 기업의 응답 내용을 1사 1파일 형식으로 출력합니다.',
    csv_modal_score_title: '스코어',
    csv_modal_score_text: '피평가 기업의 등급과 스코어를 목록으로 출력합니다.',
    csv_modal_answer_heading: '제목행',
    csv_modal_answer_heading_supplier: '피평가 기업',
    csv_modal_answer_heading_question: '설문',
    csv_modal_answer_additional: '추가 항목',
    csv_modal_answer_additional_note: '비고',
    csv_modal_answer_additional_file: '첨부파일명',
    csv_modal_cautionary_note_title: '주의 사항',
    csv_modal_cautionary_note_content: '・{questionGroupName}의 응답 상황, 응답, 스코어가 출력 대상입니다.\n・응답 상황에 대하여 조사표/서베이의 응답 상태에 상관 없이 모든 피평가 기업이 대상입니다.\n・응답, 스코어에 대하여 조사표/서베이의 응답 상태가 ‘미응답’인 피평가 기업은 대상 외입니다.\n・응답, 스코어에 대하여 1개의 CSV 파일에 표시되는 기업 수의 상한은 1,000사입니다.\n・집계된 응답, 스코어의 CSV 파일은 로그인 중인 계정의 이메일 주소로 송신됩니다.',
    csv_modal_sent_mail_section_one: 'CSV 출력 요청을 접수했습니다.',
    csv_modal_sent_mail_section_two: '이메일 주소로 CSV 다운로드 URL를 송신했으므로잠시 기다려주세요.',
    csv_modal_sent_mail_section_three: '30분 후에도 메일이 오지 않으면 다시 시도해 주세요.',
  },
  overall_score_section: {
    card_title: '조사 내용',
    score: '스코어',
    esg_score: 'ESG 스코어',
    esg_rating: 'ESG 등급',
    esg_score_tip: 'ESG 스코어란 귀사의 ESG 대응에 대한 평가를 점수화한 수치입니다. ASUENE ESG의 조사표/서베이에 대한 응답 내용을 바탕으로 산출됩니다.',
    esg_rating_tip: 'ESG 등급이란 귀사의 ESG 대응 수준을 절대 평가로 나타낸 것입니다. ESG 스코어를 근거로 AAA~CCC의 7단계로 분류됩니다.',
    evaluator_advice_title: '평가 코멘트',
    list_header_buyer_company_name: '평가 의뢰 기업',
    list_header_supplier_company_name: '피평가 기업',
    list_header_question: '조사표',
    list_header_create_at: '발행일',
    list_header_deadline: '유효기한',
    list_header_industry: '업종',
    list_header_company_scale: '사원 수',
    list_header_status: '상태',
    download_csv: 'CSV 출력',
    download_pdf: 'PDF 출력',
    // csv_title_for_buyer: "",
    csv_title_for_supplier: 'ASUENE ESG',
    answer: '@:upload_common.question_group_download_answered_csv_title',
    download_answer_description: 'CSV로 응답이 다운로드됩니다',
    answer_pdf: '@:upload_common.question_group_download_answered_pdf_title',
    download_answer_pdf_description: 'PDF로 응답이 다운로드됩니다',
    scorecard_pdf: '스코어카드(PDF)',
    download_scorecard_pdf_description: 'PDF로 스코어가 다운로드됩니다',
    feedback: '평가 피드백',
    attached_file: "@:{'improvementplans.attached_file'}",
    download_feedback_description: 'PDF로 자료가 다운로드됩니다',
    award_medal_svg: 'ESG 어워드(SVG)',
    download_award_medal_svg_description: 'SVG 이미지가 다운로드됩니다',
    award_medal_png: 'ESG 어워드(PNG)',
    download_award_medal_png_description: 'PNG 이미지가 다운로드됩니다',
    pdf_modal_sent_mail_section_one: 'PDF 출력 요청을 접수했습니다.',
    pdf_modal_sent_mail_section_two: '이메일 주소로 PDF 다운로드 URL를 송신했으므로잠시 기다려주세요.',
    pdf_modal_sent_mail_section_three: '30분 후에도 메일이 오지 않으면 다시 시도해 주세요.',
  },
  category_score_section: {
    card_title: '카테고리별 스코어',
    tip: '카테고리별 스코어는 귀사의 환경, 사회, 거버넌스별 스코어 입니다. 응답하신 기업에 따라 각 카테고리의 설문 비중이 다릅니다.',
    policy: '규범・방침',
    action: '시책',
    result: '결과',
  },
  score_by_category_compared_section: {
    card_title: '카테고리별 스코어 비교',
    get_score_by_category: '획득한 카테고리별 스코어',
    esg_evaluated_all_companies_average: '아스에네 ESG가 평가한 모든 기업',
    tip: '동일한 조사표/서베이에 응답한 기업의 평균 스코어입니다. 현시점의 평균치이므로 숫자는 변동될 가능성이 있습니다.',
  },
  strengths_advice_section: {
    card_title: '평가점 및 개선점',
    strong_point: '평가점',
    advice: '개선점이',
    policies: '규범・방침',
    action: '시책',
    result: '결과',
    no_results_for_this_category: '이 카테고리에 관하여 표시할 수 있는 결과가 없습니다.',
    risk: '리스크 정도',
    indicator: '지표',
    content: '내용',
    operation: '조작',
  },
  preview: {
    go_back_to_scorecard: '스코어카드로 돌아가기',
  },
  buyer_scorecard: {
    overview_card_title: '@:overall_score_section.card_title',
    score_card_title: '@:list_table_filter.csv_modal_score_title',
    evaluation_comment_card_title: '전체 스코어 개요',
    category_card_tabs_risk: '@:improvementplans.risk',
    category_card_tabs_content: '@:scorecard.content',
    category_card_tabs_operation: '@:improvementplans.operation',
    category_card_score_title: '@:list_table_filter.csv_modal_score_title',
    category_card_score_average: '평균: ',
    category_card_score_no_score: '대상 외',
    category_card_score_earned_score: '획득한 스코어',
    category_card_details_list_title: '평가 코멘트',
    category_card_details_no_score_tip: '본 카테고리는 평가 대상 외입니다.',
    category_card_score_average_score: '타사의 평균점',
    category_card_details_title: '카테고리별 스코어 개요',
    category_card_details_strengths: '@:strengths_advice_section.strong_point',
    category_card_details_indicated_points: '@:strengths_advice_section.advice',
    no_score_tip: '평가 의뢰 기업이 정하는 평가 로직으로 채점하기 때문에 평가 대상 외인 항목입니다.',
    buyer_evaluate_tip: '평가 의뢰 기업이 정하는 평가 로직으로 채점합니다.아스에네 ESG의 평가 로직으로는 채점하지 않습니다.',
    answer_rejection_notification: '기업에게서 철회 의뢰를 받았습니다',
    answer_rejection_modal_title: '응답 반려하기',
    answer_rejection_modal_text: '반려 코멘트',
    answer_rejection_modal_content: '{companyName} 의 응답을 반려합니다. \n담당자에 대한 반려 코멘트를 아래에 기재하고, 송신해 주세요.',
    answer_rejection_dialog_content: '{companyName}의 응답을 반려했습니다.',
    answer_rejection_button_title: '반려',
  },
}
